import { Controller } from "@hotwired/stimulus"

// One modal is shared by every delivery on the contract page. The dropdown item that
// opens it carries the transfer url and delivery id, which are copied into the form.
export default class extends Controller {
  formTarget: HTMLFormElement
  inputTarget: HTMLInputElement
  deliveryIdTarget: HTMLElement
  errorTargets: HTMLElement[]

  static targets = ["form", "input", "deliveryId", "error"]

  connect() {
    this.element.addEventListener("show.bs.modal", this.prepare)
    this.element.addEventListener("shown.bs.modal", this.focus)
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.prepare)
    this.element.removeEventListener("shown.bs.modal", this.focus)
  }

  prepare = (event: Event) => {
    const trigger = (event as Event & { relatedTarget: HTMLElement }).relatedTarget
    if (!trigger) return

    this.formTarget.action = trigger.dataset.transferUrl
    this.deliveryIdTarget.textContent = trigger.dataset.deliveryId

    // Clear any error from a previous attempt
    this.inputTarget.value = ""
    this.inputTarget.classList.remove("is-invalid")
    this.formTarget.querySelectorAll(".invalid-feedback").forEach((element) => element.remove())
    this.errorTargets.forEach((element) => element.remove())
  }

  focus = () => {
    this.inputTarget.focus()
  }
}
